export enum EncodeState {
    Pending = `pending`,
    Running = `running`,
    Creating = `creating`
}

export type ElasticEncoder = {
    state: EncodeState;
    creationTime: number;
    internalIpAddress: string;
    //there is more stuff, but unused
};

export type Encoder = {
    encodeId: string;
    state: EncodeState;
    controlHostname: string;
    controlPort: number;
    controlProtocol: string;
    internalIpAddress: string;
    token: string;
    elasticEncoder: ElasticEncoder;
    maxReplaysPerSession: number;
    //there is more stuff, but unused
};
